import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.json.parse.js";
import "core-js/modules/es.json.stringify.js";
import { __decorate } from "tslib";
import store from "@/store/instance";
import { VuexModule, Module, Mutation, Action, getModule } from "vuex-module-decorators";
import {
// IQuestion,
DecorationType, IQuestionComonentType, QuestionType } from "../config/newQuestionnaire";
import { saveQuestionnaireDraft, getQuestionnaireDraftByCommtyId, checkItemExist } from "@modules/newCommunity/pages/operationTools/api/questionnaire";
import { walkArray } from "@/utils/commonUtil";
import { service } from "@modules/newCommunity/setup";
export var QuestionnaireSettingAction;
(function (QuestionnaireSettingAction) {
  QuestionnaireSettingAction[QuestionnaireSettingAction["basic_setting"] = 0] = "basic_setting";
  QuestionnaireSettingAction[QuestionnaireSettingAction["empty"] = -1] = "empty";
  QuestionnaireSettingAction[QuestionnaireSettingAction["question"] = 1] = "question";
  QuestionnaireSettingAction[QuestionnaireSettingAction["submitBtn"] = 2] = "submitBtn";
  QuestionnaireSettingAction[QuestionnaireSettingAction["submitPageBtn"] = 3] = "submitPageBtn";
})(QuestionnaireSettingAction || (QuestionnaireSettingAction = {}));
const defaultForm = {
  formLogicConfig: {
    itemShowLogics: []
  },
  verificationConfig: {
    itemVerificationList: [],
    verificationLogicSwitch: "INFO"
  },
  questionData: {
    // $ 问卷唯一id
    title: "",
    introduce: "",
    remark: "",
    hideIntro: 0,
    exitPopup: "0",
    coverUrl: "",
    tips: "确定要放弃填写吗？",
    submitTitle: "提交",
    submitText: "本活动最终解释权归爱问所有",
    status: "",
    userAuth: 0,
    popupText: "确定要放弃填写吗？ ",
    leaveBtnText: "确认",
    cancelBtnText: "取消"
  },
  basicData: {
    title: "标题",
    remark: "",
    coverSet: true,
    cover: "",
    coverIntroduce: "",
    coverBtnText: "开始答题",
    shareSet: true,
    shareCover: "https://picture.wenwo.com/fimg/2f3582051f736b9520448c8ef6693a12.jpg",
    shareTitle: "",
    shareIntroduce: "",
    submitLimit: true,
    submitLimitCount: 1,
    loginSet: true,
    joinDoctorLimit: "COMMUNITYDOCTOR",
    joinDoctorType: [],
    exitPopup: "1",
    popupText: "确定要放弃填写吗？",
    pageSet: "COMBINE",
    uniqueId: "",
    totalScore: 0,
    participateUniqueCheck: false,
    participateRepeatedCheck: false,
    participateRepeatedClassId: "",
    participateRepeatedClassName: "",
    answerTimeLimitSwitch: false,
    answerTimeLimit: 0
  },
  temBasicData: {
    title: "",
    remark: "",
    coverSet: false,
    cover: "",
    coverIntroduce: "",
    coverBtnText: "开始答题",
    shareSet: false,
    shareCover: "https://picture.wenwo.com/fimg/2f3582051f736b9520448c8ef6693a12.jpg",
    shareTitle: "",
    shareIntroduce: "",
    submitLimit: false,
    submitLimitCount: 1,
    loginSet: false,
    joinDoctorLimit: "COMMUNITYDOCTOR",
    joinDoctorType: [],
    exitPopup: "1",
    popupText: "确定要放弃填写吗？",
    pageSet: "COMBINE",
    uniqueId: "",
    totalScore: 0,
    participateUniqueCheck: false,
    participateRepeatedCheck: false,
    participateRepeatedClassId: "",
    participateRepeatedClassName: "",
    answerTimeLimitSwitch: false,
    answerTimeLimit: 0
  },
  submitData: {
    countdown: 3,
    jumpLinkType: 2,
    jumpType: 2,
    linkUrl: "index",
    picUrl: "",
    questionnaireId: "",
    qualifiedScore: 0,
    tips: "正在转入活动详情页",
    title: "您的答卷已经提交，感谢您的参与！",
    answerResultRule: [{
      isEnable: false,
      type: "answerResultScope",
      itemShowLogics: []
    }, {
      isEnable: false,
      type: "answerResultSpecified",
      itemShowLogics: []
    }],
    resultList: [],
    showAnswerScore: true,
    resultSwitch: true
  },
  activeIndex: 0,
  dataList: []
};
const jumpUrl = {
  index: {
    label: "社区首页",
    url: "index",
    value: "index"
  },
  doctors: {
    label: "名医诊室",
    url: "doctors",
    value: "doctors"
  },
  institution: {
    label: "机构列表",
    url: "institution",
    value: "institution"
  },
  tieba: {
    label: "健康圈",
    url: "tieba",
    value: "tieba"
  },
  topics: {
    label: "话题列表",
    url: "topics",
    value: "topics"
  },
  questions: {
    label: "问答列表",
    url: "tieba#qA",
    value: "questions"
  },
  article: {
    label: "文章资讯",
    url: "article",
    value: "article"
  },
  introduce: {
    label: "社区简介",
    url: "mine/about",
    value: "introduce"
  }
};
let QuestionnaireEdit = class QuestionnaireEdit extends VuexModule {
  constructor() {
    super(...arguments);
    this.isModel = "ADD";
    this.editSpecialMode = ""; // 特殊编辑模式, 强行打开单项填写
    this.questionnaireType = "QUESTIONNAIRE";
    this.questionnaireSource = "PATIENT";
    this.questionnaireProperty = "QUESTIONNAIRE";
    // public totalScore = 0;
    this.showVerifactionConfig = false;
    this.jumpUrl = jumpUrl;
    this.action = QuestionnaireSettingAction.basic_setting;
    this.questionData = defaultForm.questionData; // $ 问卷调查数据
    this.submitData = defaultForm.submitData;
    this.basicData = defaultForm.basicData;
    this.formLogicConfig = defaultForm.formLogicConfig;
    this.verificationConfig = defaultForm.verificationConfig;
    this.activeIndex = defaultForm.activeIndex; // $ 当前点击索引
    this.dataList = defaultForm.dataList;
    this.dattpaList = defaultForm.dataList;
    this.activeData = {
      componentName: QuestionType.empty,
      componentType: IQuestionComonentType.Question,
      data: {}
    };
    this.stagDataList = [];
    this.configforAllShow = false;
    // console.log("asdfasdf2");
  }
  get basicDataUniqueId() {
    return this.basicData.uniqueId;
  }
  get get_showVerifactionConfig() {
    return this.showVerifactionConfig;
  }
  get totalScore() {
    return this.basicData.totalScore;
  }
  get isConfigforAllShow() {
    return this.configforAllShow;
  }
  get calculatorQuestionnaireItems() {
    return this.dataList.filter(item => {
      if (item.componentName == QuestionType.singleChoice || item.componentName == QuestionType.singleChoicePicker) {
        return item.data.jsonConfig.openPoint == true;
      } else if (item.componentName == QuestionType.fillIn) {
        return item.data.jsonConfig.inputForm == "NUMBER";
      } else if (item.componentName == QuestionType.fillInTable) {
        // 矩阵填空题需为数字格式且已开启总计才能参与计算
        return item.data.jsonConfig.inputForm == "NUMBER" && item.data.jsonConfig.isCountTotalNumber === true;
      } else {
        return false;
      }
    });
  }
  // 设置isModel --- 查看模式;
  SET_isModel(model) {
    this.isModel = model;
  }
  SET_editSpecialMode(mode) {
    this.editSpecialMode = mode;
  }
  // 设置id;
  SET_configforAllSetting(isSetting) {
    // console.log("SET_configforAllSetting", isSetting);
    this.configforAllShow = isSetting;
  }
  // 设置id;
  SET_BASICDATA_ID(id) {
    this.basicData.uniqueId = id;
  }
  // $ 基本信息设置
  SET_QUESTIONTYPE_PROPERTY(tp) {
    this.questionnaireProperty = tp;
  }
  SET_QUESTIONTYPE_DATA(tp) {
    this.questionnaireType = tp;
  }
  SET_QUESTIONNAIRESOURCE_DATA(tp) {
    this.questionnaireSource = tp;
  }
  SET_TOTALSCORE_DATA(tp) {
    this.basicData.totalScore = tp;
  }
  // @Mutation
  // SET_BASICS_DATA() {
  //   this.action = QuestionnaireSettingAction.basic_setting;
  // }
  // $ 提交按钮设置
  SET_SUBMIT_DATA() {
    this.action = QuestionnaireSettingAction.submitBtn;
  }
  // $ 设置当前点击索引
  SET_INDEX_COMPONENTS(index) {
    this.action = QuestionnaireSettingAction.question;
    this.activeIndex = index;
    this.activeData = this.dataList[index];
  }
  // $ 拖动组件数据
  SET_DATALIST_COMPONENTS(payload) {
    console.log("SET_DATALIST_COMPONENTS", payload);
    const dataList = computeSortIndex(payload);
    this.dataList = dataList;
  }
  // $ 添加组件
  SET_ADD_COMPONENTS(payload) {
    console.log("SET_ADD_COMPONENTS", payload);
    const item = payload.item;
    const data = {
      componentName: item.componentName,
      componentType: item.type,
      data: {
        ...item.data,
        title: item.title,
        catalogIds: [],
        whetherJoinQuestionBank: false
      }
    };
    this.dataList.splice(this.activeIndex + 1, 0, data);
    this.dataList = computeSortIndex(this.dataList);
  }
  UPDATE_COMPONENTS(payload) {
    console.log("UPDATE_COMPONENTS");
    this.dataList[payload.index].data = payload.item;
  }
  // $ 删除组件
  SET_DELETE_COMPONENTS(payload) {
    console.warn("payload", payload);
    this.dataList.splice(payload, 1);
    this.dataList = computeSortIndex(this.dataList);
    console.warn("dataList", this.dataList);
    if (this.dataList.length == 0) {
      this.action = QuestionnaireSettingAction.basic_setting;
    }
  }
  // $ 问卷调查数据
  SET_BASIC_DATA(payload) {
    this.basicData = payload;
  }
  // $ 获取问卷调查数据
  SET_DATA_LIST(payload) {
    this.dataList = payload;
    this.dataList = computeSortIndex(this.dataList);
  }
  SET_DATA_LIST_SKIPINDEX(payload) {
    this.dataList = computeSortIndex(payload, true);
  }
  // $ 获取提交页设置数据
  SET_FORM_LOGIC_CONFIG(payload) {
    this.formLogicConfig = payload;
  }
  SET_verificationConfig_verificationLogicSwitch(payload) {
    this.verificationConfig.verificationLogicSwitch = payload;
  }
  SET_verificationConfig(payload) {
    this.verificationConfig = payload;
  }
  SET_SUBMIT_LIST(payload) {
    this.submitData = payload;
  }
  SET_BASIC_LIST(payload) {
    this.basicData = payload;
  }
  SET_BASIC_DATA_SHARECOVER(payload) {
    this.basicData.shareCover = payload;
  }
  SET_BASIC_DATA_UNIQUE(payload) {
    this.basicData.participateUniqueCheck = payload;
  }
  SET_BASIC_DATA_REPEATED(payload) {
    this.basicData.participateRepeatedCheck = payload;
    if (!payload) this.basicData.participateRepeatedClassId = "";
  }
  SET_BASIC_DATA_REPEATEDCLASSID(payload) {
    this.basicData.participateRepeatedClassId = payload;
  }
  SET_BASIC_DATA_REPEATEDCLASSNAME(payload) {
    this.basicData.participateRepeatedClassName = payload;
  }
  SET_showVerificationConfig(payload) {
    // console.log("SET_showVerificationConfig", payload);
    this.showVerifactionConfig = payload;
  }
  // $ 重置数据
  SET_RESET_STORE() {
    this.questionnaireType = "QUESTIONNAIRE";
    this.questionnaireProperty = "ACTIVITY_INTERACT";
    this.configforAllShow = false;
    this.questionData = JSON.parse(JSON.stringify(defaultForm.questionData));
    this.formLogicConfig = JSON.parse(JSON.stringify(defaultForm.formLogicConfig));
    this.verificationConfig = JSON.parse(JSON.stringify(defaultForm.verificationConfig));
    this.submitData = JSON.parse(JSON.stringify(defaultForm.submitData));
    if (this.questionnaireSource == "DOCTOR") {
      this.submitData.jumpLinkType = 2;
      this.submitData.linkUrl = "";
    }
    this.basicData = JSON.parse(JSON.stringify(defaultForm.temBasicData));
    this.activeIndex = JSON.parse(JSON.stringify(defaultForm.activeIndex));
    this.dataList = JSON.parse(JSON.stringify(defaultForm.dataList));
    this.dataList = computeSortIndex(this.dataList);
  }
  SET_TEMP_RESET_STORE() {
    this.questionnaireType = "QUESTIONNAIRE";
    this.configforAllShow = false;
    this.questionData = JSON.parse(JSON.stringify(defaultForm.questionData));
    this.formLogicConfig = JSON.parse(JSON.stringify(defaultForm.formLogicConfig));
    this.verificationConfig = JSON.parse(JSON.stringify(defaultForm.verificationConfig));
    this.submitData = JSON.parse(JSON.stringify(defaultForm.submitData));
    if (this.questionnaireSource == "DOCTOR") {
      this.submitData.jumpLinkType = 2;
      this.submitData.linkUrl = "";
    }
    this.basicData = JSON.parse(JSON.stringify(defaultForm.temBasicData));
    this.activeIndex = JSON.parse(JSON.stringify(defaultForm.activeIndex));
    this.dataList = JSON.parse(JSON.stringify(defaultForm.dataList));
    this.dataList = computeSortIndex(this.dataList);
  }
  // $
  SET_NUMBER_INDEX(payload) {
    this.dataList[payload.index].data.number = payload.number;
  }
  // * 设置从题库中选择的数据
  SET_STAG_DATA_LIST(payload) {
    this.stagDataList = payload;
  }
  // * 重置从题库中选择的数据
  RESET_STAG_DATA_LIST() {
    this.stagDataList = [];
  }
  // // $ 隐藏问卷介绍
  // @Mutation
  // SET_HIDE_INTRO(payload: any) {
  //   this.questionData.hideIntro = payload;
  // }
  // @Action({commit: 'updatePosts'})
  // async function fetchPosts() {
  //     return await get('https://jsonplaceholder.typicode.com/posts')
  // }
  // $ 获取问卷详情
  async GET_QUESTIONNAIRE_DETAIL(id) {
    const res = await service.questionnaireGetDetailById({
      id
    });
    const data = res.data;
    // if (Object.keys(data).length > 1) {
    const result = transformToUIData(data);
    this.SET_FORM_LOGIC_CONFIG(result.formLogicConfig);
    this.SET_verificationConfig(result.verificationConfig);
    this.SET_BASIC_DATA(result.basicData);
    this.SET_DATA_LIST(result.datalist);
    this.SET_SUBMIT_LIST(result.submitData);
    // }
    return data;
  }
  async INTERT_ANSWER_DETAIL(itemList) {
    const dataList = JSON.parse(JSON.stringify(this.dataList));
    const newDataList = [];
    itemList.forEach(item => {
      const oindex = dataList.findIndex(oitem => {
        return oitem.data.id == item.id;
      });
      if ([1, 2, 9, 10, 3, 12, 11, 23, 21, 22, 13, 14, 6, 25, 26, 27, 28, 29, 30].includes(item.type)) {
        // if (item.answer) {
        //   item.answer = JSON.parse(item.answer);
        // }
        // 单选多选 回填答案
        // console.log("INTERT_ANSWER_DETAILoindex", oindex);
        if (oindex >= 0) {
          dataList[oindex].data.answered = item.answer;
          dataList[oindex].data.answerScore = item.answerScore;
          dataList[oindex].data.rightAnswer = item.rightAnswer;
          if (item.type == 1) {
            if (item.answer) {
              dataList[oindex].data.answer = item.answer[0] ? item.answer[0].id : "";
              const answerOptionIndex = dataList[oindex].data.optionsList.findIndex(op => {
                return op.id == dataList[oindex].data.answer;
              });
              if (answerOptionIndex >= 0) {
                const content1 = dataList[oindex].data.jsonConfig.otherInputForm !== "NUMBER" ? item.answer[0] ? item.answer[0].content : "" : item.answer[0] ? item.answer[0].content : undefined;
                dataList[oindex].data.optionsList[answerOptionIndex].otherInputAnswer = content1;
                // console.log("dataList", dataList[oindex].data);
                const content2 = dataList[oindex].data.jsonConfig.secondOtherInputForm !== "NUMBER" ? item.answer[0] ? item.answer[0].content2 : "" : item.answer[0] ? item.answer[0].content2 : undefined;
                dataList[oindex].data.optionsList[answerOptionIndex].otherInputAnswer2 = content2;
              }
            } else {
              dataList[oindex].data.answer = "";
            }
          }
          if (item.type == 2 && item.answer) {
            if (item.answer) {
              dataList[oindex].data.answer = item.answer.map(as => {
                return as.id;
              });
              if (item.answer.length > 0) {
                item.answer.forEach(oas => {
                  const answerOptionIndex = dataList[oindex].data.optionsList.findIndex(op => {
                    return op.id == oas.id;
                  });
                  if (answerOptionIndex >= 0) {
                    // console.log("dataList", dataList[oindex].data, oas);
                    const content1 = dataList[oindex].data.jsonConfig.otherInputForm !== "NUMBER" ? oas.content ? oas.content : "" : oas.content ? oas.content : undefined;
                    dataList[oindex].data.optionsList[answerOptionIndex].otherInputAnswer = content1;
                    const content2 = dataList[oindex].data.jsonConfig.secondOtherInputForm !== "NUMBER" ? oas.content2 ? oas.content2 : "" : oas.content2 ? oas.content2 : undefined;
                    dataList[oindex].data.optionsList[answerOptionIndex].otherInputAnswer2 = content2;
                  }
                });
              }
            } else {
              dataList[oindex].data.answer = [];
            }
          }
          if (item.type == 9) {
            if (item.answer) {
              dataList[oindex].data.answer = item.answer.id;
            }
          }
          if (item.type == 10) {
            if (item.answer) {
              dataList[oindex].data.answer = item.answer.map(as => {
                return as.id;
              });
            }
          }
          if (item.type == 3) {
            if (item.answer) {
              dataList[oindex].data.answer = item.answer.input;
            }
          }
          if (item.type == 12) {
            if (item.answer) {
              dataList[oindex].data.answer = item.answer;
            }
          }
          if (item.type == 11) {
            if (item.answer) {
              dataList[oindex].data.answer = item.answer;
              if (dataList[oindex].data.jsonConfig && dataList[oindex].data.jsonConfig.inputList) {
                dataList[oindex].data.jsonConfig.inputList.forEach((input, index) => {
                  if (item.answer[index]) {
                    input.answer = item.answer[index].answer;
                  }
                });
              }
            }
          }
          if (item.type == 23) {
            if (item.answer) {
              dataList[oindex].data.answer = item.answer;
            }
          }
          if (item.type == 21) {
            if (item.answer) {
              dataList[oindex].data.answer = item.answer;
            }
          }
          if (item.type == 22) {
            if (item.answer) {
              dataList[oindex].data.answer = item.answer;
            }
          }
          if (item.type == 13) {
            if (item.answer) {
              dataList[oindex].data.answer = item.answer.dateTime;
            }
          }
          if (item.type == 14) {
            if (item.answer) {
              dataList[oindex].data.answer = item.answer;
            }
          }
          if (item.type == 6) {
            if (item.answer) {
              dataList[oindex].data.answer = item.answer.urls.split(",");
            }
          }
          if (item.type == 25) {
            if (item.answer) {
              dataList[oindex].data.answer = item.answer.input;
            }
          }
          if (item.type == 26) {
            if (item.answer) {
              dataList[oindex].data.answer = item.answer;
            }
          }
          if (item.type == 27) {
            if (item.answer) {
              dataList[oindex].data.answer = item.answer[0].id;
            }
          }
          if (item.type == 28) {
            if (item.answer) {
              dataList[oindex].data.answer = item.answer.dateTime;
            }
          }
          if (item.type == 29) {
            if (item.answer) {
              dataList[oindex].data.answer = item.answer;
            }
          }
          if (item.type == 30) {
            if (item.answer) {
              dataList[oindex].data.answer = item.answer;
            }
          }
          // dataList[oindex].data.optionsList.forEach((op: any) => {
          //   op.answered = item.answer.some((as: any) => {
          //     return op.id == as.id;
          //   });
          // });
        }
      }
      newDataList.push(dataList[oindex]);
    });
    // console.log("INTERT_ANSWER_DETAIL", dataList);
    this.SET_DATA_LIST_SKIPINDEX(newDataList);
    // return data;
  }
  // $ 保存暂存数据
  async SAVE_QUESTIONNAIRE_DRAFT() {
    const basicData = this.basicData;
    const questionnaireType = this.questionnaireType;
    const questionnaireSource = this.questionnaireSource;
    const questionnaireProperty = this.questionnaireProperty;
    const formLogicConfig = this.formLogicConfig;
    const verificationConfig = this.verificationConfig;
    const params = transformToServerData(store.state, questionnaireType, questionnaireSource, basicData, this.dataList, this.submitData, formLogicConfig, questionnaireProperty, verificationConfig);
    return saveQuestionnaireDraft(params).then(data => {
      return data;
    }).catch(error => {
      return error;
    });
  }
  // $ 保存问卷
  async SAVE_QUESTIONNAIRE(id) {
    console.log("SAVE_QUESTIONNAIRE", id);
    const basicData = this.basicData;
    const questionnaireType = this.questionnaireType;
    const questionnaireSource = this.questionnaireSource;
    const formLogicConfig = JSON.parse(JSON.stringify(this.formLogicConfig));
    const verificationConfig = JSON.parse(JSON.stringify(this.verificationConfig));
    // console.log("SAVE_TEMPLATEthis.dataList", this.dataList);
    const params = transformToServerData(store.state, questionnaireType, questionnaireSource, basicData, this.dataList, this.submitData, formLogicConfig, this.questionnaireProperty, verificationConfig);
    params.id = id;
    params.status = 1;
    // console.log("SAVE_TEMPLATEthis.dataListparams", params);
    return await service.saveQuestionnaire(params).then(data => {
      return data;
    }).catch(error => {
      return error;
    });
  }
  // $ 保存问卷
  async SAVE_TEMPLATE(id) {
    console.log("SAVE_TEMPLATE", status);
    const basicData = this.basicData;
    const questionnaireType = this.questionnaireType;
    const questionnaireSource = this.questionnaireSource;
    const formLogicConfig = JSON.parse(JSON.stringify(this.formLogicConfig));
    const verificationConfig = JSON.parse(JSON.stringify(this.verificationConfig));
    // console.log("SAVE_TEMPLATEthis.dataList", this.dataList);
    const params = transformToServerData(store.state, questionnaireType, questionnaireSource, basicData, this.dataList, this.submitData, formLogicConfig, this.questionnaireProperty, verificationConfig);
    params.id = id;
    return await service.questionnaireTemplateSave(params).then(data => {
      return data;
    }).catch(error => {
      return error;
    });
  }
  /////////////////
  // 2024年6月4日12:06:29 活动内保存模板库 且换名字
  // @Action
  // async SAVE_TEMPLATE_WITHTITLE(title: string) {
  //   // const basicData = this.basicData;
  //   // const questionnaireType = this.questionnaireType;
  //   // const questionnaireSource = this.questionnaireSource;
  //   // const formLogicConfig = JSON.parse(JSON.stringify(this.formLogicConfig));
  //   // console.log("SAVE_TEMPLATEthis.dataList", this.dataList);
  //   // const params = transformToServerData(store.state, questionnaireType, questionnaireSource, basicData, this.dataList, this.submitData, formLogicConfig);
  //   params.id = "";
  //   params.title = title;
  //   params.status = 1;
  //   // console.log("SAVE_TEMPLATEthis.dataListparams", params);
  //   return await service
  //     .questionnaireTemplateSave(params as any)
  //     .then((data: any) => {
  //       return data;
  //     })
  //     .catch((error: any) => {
  //       return error;
  //     });
  // }
  ///////////////////
  //2024年6月4日12:06:39 活动内保存下线模板
  async SAVE_ACTIVITY_TEMPLATE(id) {
    console.log("SAVE_TEMPLATE", id);
    const basicData = this.basicData;
    const questionnaireType = this.questionnaireType;
    const questionnaireSource = this.questionnaireSource;
    const formLogicConfig = JSON.parse(JSON.stringify(this.formLogicConfig));
    const verificationConfig = JSON.parse(JSON.stringify(this.verificationConfig));
    // console.log("SAVE_TEMPLATEthis.dataList", this.dataList);
    const params = transformToServerData(store.state, questionnaireType, questionnaireSource, basicData, this.dataList, this.submitData, formLogicConfig, this.questionnaireProperty, verificationConfig);
    params.id = id;
    params.status = 0;
    // console.log("SAVE_TEMPLATEthis.dataListparams", params);
    return await service.questionnaireTemplateSave(params).then(data => {
      return data;
    }).catch(error => {
      return error;
    });
  }
  // $ 新增/保存问卷模板
  async UPDATE_TEMPLATE(id) {
    const basicData = this.basicData;
    const questionnaireType = this.questionnaireType;
    const questionnaireSource = this.questionnaireSource;
    const formLogicConfig = JSON.parse(JSON.stringify(this.formLogicConfig));
    const verificationConfig = JSON.parse(JSON.stringify(this.verificationConfig));
    console.log("SAVE_TEMPLATEthis.dataList", this.dataList);
    const params = transformToServerData(store.state, questionnaireType, questionnaireSource, basicData, this.dataList, this.submitData, formLogicConfig, this.questionnaireProperty, verificationConfig);
    params.id = id;
    console.log("SAVE_TEMPLATEthis.dataListparams", params);
    return await service.questionnaireTemplateSave(params).then(res => {
      return res;
    }).catch(error => {
      return error;
    });
  }
  // $ 获取暂存数据
  async GET_TEMPLATE(id) {
    return service.questionnaireTemplateGetDetail({
      id
    }).then(res => {
      console.log("formtemplateGetDetail", res);
      const data = res.data;
      // if (Object.keys(data).length > 1) {
      const result = transformToUIData(data);
      this.SET_FORM_LOGIC_CONFIG(result.formLogicConfig);
      this.SET_verificationConfig(result.verificationConfig);
      this.SET_BASIC_DATA(result.basicData);
      this.SET_DATA_LIST(result.datalist);
      this.SET_SUBMIT_LIST(result.submitData);
      // }
      return data;
    }).catch(error => {
      return error;
    });
  }
  // $ 获取暂存数据
  async GET_QUESTIONNAIREDraftByCommtyId() {
    // const questionData = this.questionData;
    return getQuestionnaireDraftByCommtyId({
      communityId: store.state.comtyId,
      questionnaireType: this.questionnaireType,
      questionnaireSource: this.questionnaireSource
    }).then(res => {
      console.warn("getQuestionnaireDraftByCommtyId", res);
      const data = res.data;
      if (Object.keys(data).length > 1) {
        const result = transformToUIData(data);
        this.SET_BASIC_DATA(result.basicData);
        this.SET_DATA_LIST(result.datalist);
        this.SET_SUBMIT_LIST(result.submitData);
      }
      return data;
    }).catch(error => {
      return error;
    });
  }
  // $ 设置问卷模板数据（查看、编辑）
  // @Action
  // async SET_TEMPLATE(id: string) {
  //   return service
  //     .questionnaireTemplateGetDetail({ id })
  //     .then((res: any) => {
  //       console.log("formtemplateGetDetail", res);
  //       const data: any = res.data;
  //       // if (Object.keys(data).length > 1) {
  //       const result = transformToUIData(data);
  //       this.SET_FORM_LOGIC_CONFIG(result.formLogicConfig);
  //       // TODO: SET_BASIC_DATA SET_SUBMIT_LIST
  //       this.SET_BASIC_DATA(result.basicData);
  //       this.SET_DATA_LIST(result.datalist);
  //       this.SET_SUBMIT_LIST(result.submitData);
  //       // }
  //       return data;
  //     })
  //     .catch((error: any) => {
  //       return error;
  //     });
  // }
  async CHECK_DATA() {
    const basicData = this.basicData;
    const questionnaireType = this.questionnaireType;
    const questionnaireSource = this.questionnaireSource;
    const formLogicConfig = this.formLogicConfig;
    const verificationConfig = this.verificationConfig;
    // console.log("asdfasdf");
    try {
      const params = transformToServerData(store.state, questionnaireType, questionnaireSource, basicData, this.dataList, this.submitData, formLogicConfig, this.questionnaireProperty, verificationConfig);
      return await checkItemExist(params).then(data => {
        return data;
      }).catch(error => {
        return error;
      });
    } catch (error) {
      console.log("asdfasdf3", error);
    }
  }
};
__decorate([Mutation], QuestionnaireEdit.prototype, "SET_isModel", null);
__decorate([Mutation], QuestionnaireEdit.prototype, "SET_editSpecialMode", null);
__decorate([Mutation], QuestionnaireEdit.prototype, "SET_configforAllSetting", null);
__decorate([Mutation], QuestionnaireEdit.prototype, "SET_BASICDATA_ID", null);
__decorate([Mutation], QuestionnaireEdit.prototype, "SET_QUESTIONTYPE_PROPERTY", null);
__decorate([Mutation], QuestionnaireEdit.prototype, "SET_QUESTIONTYPE_DATA", null);
__decorate([Mutation], QuestionnaireEdit.prototype, "SET_QUESTIONNAIRESOURCE_DATA", null);
__decorate([Mutation], QuestionnaireEdit.prototype, "SET_TOTALSCORE_DATA", null);
__decorate([Mutation], QuestionnaireEdit.prototype, "SET_SUBMIT_DATA", null);
__decorate([Mutation], QuestionnaireEdit.prototype, "SET_INDEX_COMPONENTS", null);
__decorate([Mutation], QuestionnaireEdit.prototype, "SET_DATALIST_COMPONENTS", null);
__decorate([Mutation], QuestionnaireEdit.prototype, "SET_ADD_COMPONENTS", null);
__decorate([Mutation], QuestionnaireEdit.prototype, "UPDATE_COMPONENTS", null);
__decorate([Mutation], QuestionnaireEdit.prototype, "SET_DELETE_COMPONENTS", null);
__decorate([Mutation], QuestionnaireEdit.prototype, "SET_BASIC_DATA", null);
__decorate([Mutation], QuestionnaireEdit.prototype, "SET_DATA_LIST", null);
__decorate([Mutation], QuestionnaireEdit.prototype, "SET_DATA_LIST_SKIPINDEX", null);
__decorate([Mutation], QuestionnaireEdit.prototype, "SET_FORM_LOGIC_CONFIG", null);
__decorate([Mutation], QuestionnaireEdit.prototype, "SET_verificationConfig_verificationLogicSwitch", null);
__decorate([Mutation], QuestionnaireEdit.prototype, "SET_verificationConfig", null);
__decorate([Mutation], QuestionnaireEdit.prototype, "SET_SUBMIT_LIST", null);
__decorate([Mutation], QuestionnaireEdit.prototype, "SET_BASIC_LIST", null);
__decorate([Mutation], QuestionnaireEdit.prototype, "SET_BASIC_DATA_SHARECOVER", null);
__decorate([Mutation], QuestionnaireEdit.prototype, "SET_BASIC_DATA_UNIQUE", null);
__decorate([Mutation], QuestionnaireEdit.prototype, "SET_BASIC_DATA_REPEATED", null);
__decorate([Mutation], QuestionnaireEdit.prototype, "SET_BASIC_DATA_REPEATEDCLASSID", null);
__decorate([Mutation], QuestionnaireEdit.prototype, "SET_BASIC_DATA_REPEATEDCLASSNAME", null);
__decorate([Mutation], QuestionnaireEdit.prototype, "SET_showVerificationConfig", null);
__decorate([Mutation], QuestionnaireEdit.prototype, "SET_RESET_STORE", null);
__decorate([Mutation], QuestionnaireEdit.prototype, "SET_TEMP_RESET_STORE", null);
__decorate([Mutation], QuestionnaireEdit.prototype, "SET_NUMBER_INDEX", null);
__decorate([Mutation], QuestionnaireEdit.prototype, "SET_STAG_DATA_LIST", null);
__decorate([Mutation], QuestionnaireEdit.prototype, "RESET_STAG_DATA_LIST", null);
__decorate([Action], QuestionnaireEdit.prototype, "GET_QUESTIONNAIRE_DETAIL", null);
__decorate([Action({
  rawError: true
})], QuestionnaireEdit.prototype, "INTERT_ANSWER_DETAIL", null);
__decorate([Action], QuestionnaireEdit.prototype, "SAVE_QUESTIONNAIRE_DRAFT", null);
__decorate([Action], QuestionnaireEdit.prototype, "SAVE_QUESTIONNAIRE", null);
__decorate([Action], QuestionnaireEdit.prototype, "SAVE_TEMPLATE", null);
__decorate([Action], QuestionnaireEdit.prototype, "SAVE_ACTIVITY_TEMPLATE", null);
__decorate([Action], QuestionnaireEdit.prototype, "UPDATE_TEMPLATE", null);
__decorate([Action], QuestionnaireEdit.prototype, "GET_TEMPLATE", null);
__decorate([Action], QuestionnaireEdit.prototype, "GET_QUESTIONNAIREDraftByCommtyId", null);
__decorate([Action], QuestionnaireEdit.prototype, "CHECK_DATA", null);
QuestionnaireEdit = __decorate([Module({
  name: "newQuestionnaireEditNew",
  dynamic: true,
  namespaced: true,
  store
})], QuestionnaireEdit);
export default QuestionnaireEdit;
// !初始化问卷答题数据
export function transformToUIData(data) {
  console.log("transformToUIData", data);
  try {
    const formLogicConfig = data.formLogicConfig;
    const verificationConfig = data.verificationConfig;
    const basicData = {
      uniqueId: data.id || undefined,
      title: data.title,
      remark: data.remark,
      coverSet: data.coverSet || false,
      cover: data.cover || "",
      coverIntroduce: data.coverIntroduce || "",
      coverBtnText: data.coverBtnText || "",
      shareSet: data.shareSet || false,
      shareCover: data.shareCover || "https://picture.wenwo.com/fimg/2f3582051f736b9520448c8ef6693a12.jpg",
      shareTitle: data.shareTitle || "",
      shareIntroduce: data.shareIntroduce || "",
      submitLimit: data.submitLimit || false,
      submitLimitCount: data.submitLimitCount || 1,
      loginSet: data.loginSet || false,
      joinDoctorLimit: data.joinDoctorLimit || "COMMUNITYDOCTOR",
      joinDoctorType: data.joinDoctorType || [],
      exitPopup: data.exitPopup + "",
      popupText: data.popupText,
      pageSet: data.pageSet,
      totalScore: data.totalScore,
      participateUniqueCheck: data.participateUniqueCheck,
      participateRepeatedCheck: data.participateRepeatedCheck,
      participateRepeatedClassId: data.participateRepeatedClassId,
      participateRepeatedClassName: data.participateRepeatedClassName,
      answerTimeLimitSwitch: data.answerTimeLimitSwitch || false,
      answerTimeLimit: data.answerTimeLimit || 0
    };
    const serviceSubmitData = data.submitItemList ? data.submitItemList[0] : {};
    const submitData = {
      countdown: serviceSubmitData.countdown,
      jumpLinkType: serviceSubmitData.jumpLinkType || 1,
      jumpType: serviceSubmitData.jumpType || 0,
      linkUrl: serviceSubmitData.linkUrl,
      picUrl: serviceSubmitData.picUrl,
      questionnaireId: serviceSubmitData.questionnaireId,
      tips: serviceSubmitData.tips,
      title: serviceSubmitData.title,
      qualifiedScore: data.qualifiedScore || 0,
      resultList: data.resultList,
      showAnswerScore: data.showAnswerScore,
      resultSwitch: data.resultSwitch,
      answerResultRule: []
    };
    const answerResultRule = [];
    if (data.answerResultRule) {
      if (data.answerResultRule.answerResultScope.priorityIndex == 0) {
        answerResultRule.push({
          ...data.answerResultRule.answerResultScope,
          type: "answerResultScope"
        });
        answerResultRule.push({
          ...data.answerResultRule.answerResultSpecified,
          type: "answerResultSpecified"
        });
      } else {
        answerResultRule.push({
          ...data.answerResultRule.answerResultSpecified,
          type: "answerResultSpecified"
        });
        answerResultRule.push({
          ...data.answerResultRule.answerResultScope,
          type: "answerResultScope"
        });
      }
    }
    submitData.answerResultRule = answerResultRule;
    const datalist = [];
    walkArray(data.itemList, item => {
      const question = {
        componentName: item.type,
        componentStyle: item.style,
        data: {
          id: item.id,
          required: item.required,
          number: item.number,
          type: item.type,
          style: item.style,
          whetherJoinQuestionBank: item.joinBank || false,
          fromQuestionBank: !!item.fromQuestionBank,
          catalogIds: item.catalogIds || []
        }
      };
      if (item.type == QuestionType.singleChoice || item.type == QuestionType.multipleChoice || item.type == QuestionType.cascade || item.type == QuestionType.singleChoicePicker || item.type == QuestionType.multipleChoicePicker || item.type == QuestionType.sex || item.type == QuestionType.diagnosis) {
        const data = question.data;
        item.optionsList.forEach(op => {
          if (op.jsonConfig) {
            op.jsonConfig = JSON.parse(op.jsonConfig);
          } else {
            op.jsonConfig = {
              exclusive: false
            };
          }
        });
        data.optionsList = item.optionsList;
        data.jsonConfig = JSON.parse(item.jsonConfig);
        data.title = item.question;
        data.optionContentType = item.optionContentType;
        data.itemScore = item.itemScore || 0;
        data.scoreRule = item.scoreRule;
        //       optionContentType: string; // 是否必填: number;
        // itemScore?: number;
      }
      if (item.type == DecorationType.cutOffLine) {
        const data = question.data;
        const jsonConfig = JSON.parse(item.jsonConfig);
        data.jsonConfig = jsonConfig;
      }
      if (item.type == QuestionType.department || item.type == QuestionType.fillInMulti || item.type == QuestionType.fillInRange || item.type == QuestionType.dateTime || item.type == QuestionType.addressInput || item.type == QuestionType.diagnosisTime || item.type == QuestionType.onlineBooking) {
        const data = question.data;
        data.title = item.question;
        data.jsonConfig = JSON.parse(item.jsonConfig);
      }
      if (item.type == DecorationType.picture) {
        const data = question.data;
        try {
          const jsonConfig = JSON.parse(item.jsonConfig);
          data.url = jsonConfig.url;
        } catch (error) {
          console.log(error, item.jsonConfig);
          data.url = "";
        }
      }
      if (item.type == DecorationType.text) {
        const data = question.data;
        try {
          const jsonConfig = JSON.parse(item.jsonConfig);
          data.text = jsonConfig.text;
        } catch (error) {
          console.log(error, item.jsonConfig);
          data.text = "";
        }
      }
      if (item.type == QuestionType.uploadAddon) {
        const data = question.data;
        data.title = item.question;
        data.jsonConfig = JSON.parse(item.jsonConfig);
        data.uploadLimitCount = item.uploadLimitCount;
      }
      if (item.type == QuestionType.phoneNumber) {
        const data = question.data;
        data.title = item.question;
        try {
          const jsonConfig = JSON.parse(item.jsonConfig);
          data.phoneNumber = jsonConfig.default; //填空题的默认文本
        } catch (error) {
          console.log(error, item.jsonConfig);
          data.phoneNumber = "";
        }
      }
      if (item.type == QuestionType.fillIn || item.type == QuestionType.patientName || item.type == QuestionType.age) {
        const data = question.data;
        data.title = item.question;
        data.jsonConfig = JSON.parse(item.jsonConfig);
        data.itemScore = item.itemScore;
        data.rightText = item.rightText;
        data.scoreRule = item.scoreRule;
        try {
          const jsonConfig = JSON.parse(item.jsonConfig);
          data.content = jsonConfig.default; //填空题的默认文本
        } catch (error) {
          console.log(error, item.jsonConfig);
          data.content = "";
        }
      }
      if (item.type == QuestionType.sort) {
        const data = question.data;
        data.title = item.question;
        data.optionsList = item.optionsList;
        data.optionContentType = item.optionContentType;
        data.jsonConfig = JSON.parse(item.jsonConfig);
      }
      if (item.type == QuestionType.proportion) {
        const data = question.data;
        data.title = item.question;
        data.optionsList = item.optionsList;
        data.optionContentType = item.optionContentType;
        data.jsonConfig = JSON.parse(item.jsonConfig);
      }
      if (item.type == QuestionType.fillInTable) {
        const data = question.data;
        data.title = item.question;
        data.optionsList = item.optionsList;
        data.jsonConfig = JSON.parse(item.jsonConfig);
      }
      if (item.type == DecorationType.calculator) {
        const data = question.data;
        data.title = item.question;
        data.jsonConfig = JSON.parse(item.jsonConfig);
      }
      // (question.data as IQuestion).whetherJoinQuestionBank = false;
      datalist.push(question);
    });
    return {
      basicData,
      datalist,
      submitData,
      formLogicConfig,
      verificationConfig
    };
  } catch (error) {
    console.log("transformToUIDataerror", error);
    return {};
  }
}
function transformToServerData(rootState, questionnaireType, questionnaireSource, basicData, dataList, submitData, formLogicConfig, questionnaireProperty, verificationConfig) {
  const itemList = transformDataListToServerData(dataList);
  const params = {
    formLogicConfig,
    verificationConfig,
    questionnaireType,
    questionnaireSource,
    ...basicData,
    submitItemList: [submitData],
    qualifiedScore: submitData.qualifiedScore || 0,
    itemList: itemList,
    questionnaireProperty: questionnaireProperty,
    // formProperty: "ACTIVITY_INTERACT",
    resultList: submitData.resultList,
    showAnswerScore: submitData.showAnswerScore,
    resultSwitch: submitData.resultSwitch
  };
  //转换提交步骤的数据
  const answerResultRule = {};
  if (submitData.answerResultRule && submitData.answerResultRule.length) {
    submitData.answerResultRule.forEach((rule, index) => {
      answerResultRule[rule.type] = {
        ...rule,
        priorityIndex: index
      };
    });
  }
  params.answerResultRule = answerResultRule;
  if (questionnaireSource == "PATIENT") {
    delete params.joinDoctorLimit;
    delete params.joinDoctorType;
  }
  // console.log("transformToServerData", params);
  return params;
}
export function transformDataListToServerData(datalist) {
  const data = datalist.map(item => {
    const formData = item.data;
    // console.warn("formData1", formData);
    const question = {
      required: formData.required,
      type: item.componentName,
      style: item.componentType,
      number: formData.number,
      catalogIds: formData.catalogIds || [],
      joinBank: !!formData.whetherJoinQuestionBank,
      fromQuestionBank: !!formData.fromQuestionBank
    };
    if (formData.id) question.id = formData.id;
    if (item.componentName == QuestionType.singleChoice || item.componentName == QuestionType.multipleChoice || item.componentName == QuestionType.cascade || item.componentName == QuestionType.singleChoicePicker || item.componentName == QuestionType.multipleChoicePicker || item.componentName == QuestionType.sex || item.componentName == QuestionType.diagnosis) {
      question.optionsList = JSON.parse(JSON.stringify(formData.optionsList));
      question.jsonConfig = JSON.stringify(formData.jsonConfig);
      question.question = formData.title;
      question.itemScore = formData.itemScore;
      question.scoreRule = formData.scoreRule;
      question.optionContentType = formData.optionContentType;
      // console.log("transformDataListToServerData", new Date(), question.optionsList);
      question.optionsList.forEach(op => {
        op.jsonConfig = op.jsonConfig ? JSON.stringify(op.jsonConfig) : JSON.stringify({});
      });
      if (item.componentName === QuestionType.diagnosis) {
        // 诊断题 数据处理
        question.jsonConfig = JSON.parse(question.jsonConfig);
        if (formData.optionContentType === "FILLIN") {
          // 填写类型
          question.optionsList = [];
          delete question.jsonConfig.otherInputNumberMax;
          delete question.jsonConfig.otherInputNumberMin;
          delete question.jsonConfig.selectRangeMax;
          delete question.jsonConfig.selectRangeMin;
        } else {
          delete question.jsonConfig.fillInMax;
          delete question.jsonConfig.fillInMin;
        }
        question.jsonConfig = JSON.stringify(question.jsonConfig);
      }
    }
    if (item.componentName == QuestionType.sort) {
      question.optionsList = formData.optionsList;
      question.jsonConfig = JSON.stringify(formData.jsonConfig);
      question.question = formData.title;
      question.itemScore = formData.itemScore;
      question.optionContentType = formData.optionContentType;
    }
    if (item.componentName == QuestionType.proportion) {
      question.optionsList = formData.optionsList;
      question.jsonConfig = JSON.stringify(formData.jsonConfig);
      question.question = formData.title;
      question.itemScore = formData.itemScore;
      question.optionContentType = formData.optionContentType;
    }
    if (item.componentName == QuestionType.fillIn || item.componentName === QuestionType.patientName || item.componentName == QuestionType.age) {
      const jsonConfig = {
        ...formData.jsonConfig,
        default: formData.content
      };
      question.jsonConfig = JSON.stringify(jsonConfig);
      question.question = formData.title;
      question.itemScore = formData.itemScore;
      question.rightText = formData.rightText;
      question.scoreRule = formData.scoreRule;
    }
    if (item.componentName == DecorationType.picture) {
      const jsonConfig = {
        url: formData.url
      };
      question.jsonConfig = JSON.stringify(jsonConfig);
    }
    if (item.componentName == DecorationType.text) {
      const jsonConfig = {
        text: formData.text
      };
      question.jsonConfig = JSON.stringify(jsonConfig);
    }
    if (item.componentName == QuestionType.phoneNumber) {
      const jsonConfig = {
        default: formData.phoneNumber
      };
      question.jsonConfig = JSON.stringify(jsonConfig);
      question.question = formData.title;
    }
    if (item.componentName == QuestionType.uploadAddon) {
      const data = formData;
      question.jsonConfig = JSON.stringify(data.jsonConfig);
      question.question = data.title;
      question.uploadLimitCount = data.uploadLimitCount;
    }
    if (item.componentName == DecorationType.cutOffLine) {
      question.jsonConfig = JSON.stringify(formData.jsonConfig);
      // question.question = (formData as ICutOffLineData).title;
    }
    if (item.componentName == QuestionType.department || item.componentName == DecorationType.calculator || item.componentName == QuestionType.fillInMulti || item.componentName == QuestionType.fillInRange || item.componentName == QuestionType.dateTime || item.componentName == QuestionType.addressInput || item.componentName == QuestionType.diagnosisTime) {
      question.question = formData.title;
      question.jsonConfig = JSON.stringify(formData.jsonConfig);
    }
    if (item.componentName == QuestionType.fillInTable) {
      question.optionsList = formData.optionsList;
      question.jsonConfig = JSON.stringify(formData.jsonConfig);
      question.question = formData.title;
      question.itemScore = formData.itemScore;
    }
    if (item.componentName == QuestionType.onlineBooking) {
      question.question = formData.title;
      question.jsonConfig = JSON.stringify(formData.jsonConfig);
      if (question.jsonConfig.appointmentMethod === "APPOINTMENT_METHOD_DAY") {
        question.jsonConfig.dailyStartAndEndTime = [];
        question.jsonConfig.hourlyDuration = undefined;
        question.jsonConfig.intervalTime = undefined;
      }
      if (question.jsonConfig.appointmentMethod === "UNLIMITED") question.jsonConfig.appointmentDateRange = [];
    }
    return question;
  });
  return data;
}
function computeSortIndex(dataList, TrueSort = false) {
  let sort = 0;
  dataList.forEach(item => {
    if (item.componentName == DecorationType.calculator || item.componentName == DecorationType.picture || item.componentName == DecorationType.text || item.componentName == DecorationType.cutOffLine || item.componentName == DecorationType.pageGap || TrueSort && !item.data.jsonConfig.showIndex) {
      //无需处理
      item.data.number = "";
    } else {
      item.data.number = sort;
      sort++;
    }
  });
  console.log("computeSortIndex", dataList);
  return dataList;
}
export const QuestionnaireEditModule = getModule(QuestionnaireEdit);